<template>
    <div class="fSize">
        <van-cell-group v-if="showPage" style="background:#fafafa">
            <div style="background:#fff;padding: 0.225rem;">
                <van-row type="flex" justify="space-between">
                    <van-col>订单编号：</van-col>
                    <van-col>{{buyOrder.buyOrderCode}}</van-col>
                </van-row>
                <van-row type="flex" justify="space-between" style="margin-top:0.1rem">
                    <van-col>下单时间：</van-col>
                    <van-col>{{buyOrder.createTime}}</van-col>
                </van-row>
                <van-row type="flex" justify="space-between" style="margin-top:0.1rem">
                    <van-col>商品单价：{{'￥'+buyOrder.productPrice/100}}</van-col>
                    <van-col class="textR">x{{buyOrder.buyNum}}</van-col>
                </van-row>
                <van-row type="flex" justify="space-between" style="margin-top:0.1rem">
                    <van-col>商品总价：</van-col>
                    <van-col>{{'￥'+buyOrder.buyMoney/100}}</van-col>
                </van-row>
            </div>
            <div style="margin-top:0.25rem">
                <div v-for="(item,index) in data" :key="index" class="newDiv">
                    <van-row type="flex" justify="space-between">
                        <van-col>卡片编号</van-col>
                        <van-col>{{item.cardCode?item.cardCode:'--'}}</van-col>
                    </van-row>
                    <van-row type="flex" justify="space-between" style="margin-top:0.1rem">
                        <van-col>卡片状态</van-col>
                        <van-col>{{item.status==="used"?'已使用':'未使用'}}</van-col>
                    </van-row>
                    <van-row type="flex" justify="space-between" style="margin-top:0.1rem">
                        <van-col>卡片使用人</van-col>
                        <van-col>{{item.usePersion?item.usePersion:'--'}}</van-col>
                    </van-row>
                    <van-row type="flex" justify="space-between" style="margin-top:0.1rem">
                        <van-col>使用人联系方式</van-col>
                        <van-col>{{item.usePersionPhone?item.usePersionPhone:'--'}}</van-col>
                    </van-row>
                    <van-row type="flex" justify="space-between" style="margin-top:0.1rem">
                        <van-col>体检流水号</van-col>
                        <van-col>{{item.useCode?item.useCode:'--'}}</van-col>
                    </van-row>
                    <van-row type="flex" justify="space-between" style="margin-top:0.1rem">
                        <van-col>使用时间</van-col>
                        <van-col>{{item.useTime?item.useTime:'--'}}</van-col>
                    </van-row>
                </div>
            </div>
            <van-cell v-if="data.status === '1'" :border="false" safe-area-inset-bottom>
                <van-row>
                    <van-col span="24" class="textC">
                        <van-button class="newButton" hairline plain round size="small" type="info"
                                    @click="delOrder(data.id)" text="取消订单"/>
                        <van-button class="newButton" hairline plain round size="small" type="info"
                                    @click="goOrder" text="去支付"/>
                    </van-col>
                </van-row>
            </van-cell>
            <!--<van-cell v-if="data.status === '2'" :border="false" safe-area-inset-bottom>
                      <van-row>
                          <van-col span="24" class="textC">
                              <van-button class="newButton" hairline plain round size="small" type="warning" @click="goRefund"
                                          text="退款"/>
                          </van-col>
                      </van-row>
            </van-cell>-->
        </van-cell-group>
        <van-empty v-else image="search" :description="description"/>
        <!--去支付-->
        <van-action-sheet safe-area-inset-bottom :round="false" v-model="showBase" title="订单与支付">
            <OrderAndBuy @fatherMethod="closeChild" :item="detail"></OrderAndBuy>
        </van-action-sheet>
        <!--去退款-->
        <van-action-sheet safe-area-inset-bottom :round="false" v-model="showTui" title="退款申请">
            <OrderRefund @fatherMethod="closeTui" :item="refund"></OrderRefund>
        </van-action-sheet>
    </div>
</template>
<script>
    import {
        Dialog, Toast, ActionSheet, Cell, CellGroup, Col, Row, Button, Empty
    } from "vant";
    import OrderAndBuy from "@/components/OrderAndBuy";
    import OrderRefund from "@/components/OrderRefund";
    import {getOrder, deleteOrder} from "@/api/order";
    import {getSetMeal} from "@/api/common";

    export default {
        components: {
            OrderAndBuy, OrderRefund, [ActionSheet.name]: ActionSheet, [Cell.name]: Cell, [CellGroup.name]: CellGroup,
            [Col.name]: Col, [Row.name]: Row, [Button.name]: Button, [Empty.name]: Empty
        },
        data() {
            return {
                data: {},
                showPage: false,
                description: "数据加载中...",
                buyOrder: null,
                //-----
                showBase: false,
                detail: null,
                //-----
                showTui: false,
                refund: null
            };
        },
        created() {
            const that = this;
            that.buyOrder = that.$route.query ? that.$route.query : that.buyOrder;
            // 获取订单详情
            that.getData(that.buyOrder.buyOrderCode);
        },
        methods: {
            //根据status值输出内容
            /*changeS(i) {
                let name = null;
                let color = null;
                switch (i) {
                    case "1":
                        name = "待付款";
                        color = "color:#F56C6C;";
                        break;
                    case "2":
                        name = "已付款";
                        color = "color:#E6A23C;";
                        break;
                    case "3":
                        name = "已使用";
                        color = "color:#67C23A;";
                        break;
                    case "4":
                        //name = "已使用";
                        name = "部分使用";
                        color = "color:#67C23A;";
                        break;
                    /!*case "5":
                        name = "已退款";
                        color = "color:#909399;";
                        break;*!/
                    case "6":
                        //name = "已退款";
                        name = "待退款";
                        color = "color:#909399;";
                        break;
                    default:
                        name = "全部";
                        color = "color:#000000;";
                        break;
                }
                return [name, color];
            },*/
            //根据status值输出内容
            changeStyle(i) {
                let name = null;
                let color = null;
                switch (i) {
                    case "1":
                        name = "未使用";
                        color = "color:#67C23A";
                        break;
                    case "2":
                        name = "已使用";
                        color = "color:#F56C6C";
                        break;
                    default:
                        name = "全部";
                        color = "color:#000000";
                        break;
                }
                return [name, color];
            },
            //获取订单详情
            getData(buyOrderCode) {
                const that = this;
                that.showPage = false;
                that.description = "数据加载中...";
                // 自定义加载图标
                Toast.loading({
                    message: "数据加载中...",
                    forbidClick: true,
                    duration: 0, // 持续展示 toast
                    loadingType: "spinner"
                });
                that.data = {};
                //请求参数处理
                let obj = {
                    openId: sessionStorage.getItem("openid"),
                    buyOrderCode: buyOrderCode
                };
                getOrder(obj).then(resp => {
                    Toast.clear();
                    that.data = resp.code === 200 && resp.rows ? resp.rows : [];
                    if (resp.code !== 200) {
                        that.description = resp.msg;
                    } else {
                        that.showPage = that.data !== {};
                        if (!that.showPage) {
                            that.description = "暂无有效数据！";
                        }
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            //订单删除
            delOrder(id) {
                const that = this;
                Dialog.confirm({
                    //title: '标题',
                    message: "确定取消此条订单吗？"
                }).then(() => {
                    // on confirm
                    deleteOrder({id: id, openId: sessionStorage.getItem("openid")}).then(resp => {
                        if (resp.code === 200) {
                            that.showPage = false;
                            that.description = "订单已取消...";
                            Toast.success("订单取消成功！");
                        } else {
                            Toast.fail(resp.msg);
                        }
                    }).catch(err => {
                        console.log(err);
                    });
                }).catch(() => {
                    // on cancel
                    console.log("取消了删除[" + id + "]！");
                });
            },
            //去购买
            goOrder() {
                const that = this;
                let item = that.data;
                that.detail = null;
                Toast.loading({
                    message: "数据加载中...",
                    forbidClick: true,
                    loadingType: "spinner",
                    duration: 0
                });
                getSetMeal({openId: sessionStorage.getItem("openid"), productCode: item.code}, 1).then(resp => {
                    let data = resp.code === 200 && resp.data ? resp.data : {};
                    Toast.clear();
                    if (data) {
                        //数据组装
                        data.personal = ("" + item.userId).split(","); //初始化用户
                        data.count = item.buyNum; //购买数量
                        data.code = item.code;
                        data.amount = item.buyMoney; //购买总价
                        data.buyOrderCode = item.buyOrderCode;
                        //传递子组件数据//展示子组件
                        that.detail = JSON.stringify(data);
                        that.showBase = true;
                    } else {
                        //为空处理
                        Dialog.alert({
                            message: "套餐信息不存在..."
                        }).then(() => {
                            that.$router.push({path: "/order"});
                        });
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            //去退款
            goRefund() {
                const that = this;
                let item = that.data;
                //传递子组件数据//展示子组件
                that.refund = JSON.stringify(item);
                that.showTui = true;
            },
            //关闭子组件窗口
            closeChild() {
                const that = this;
                that.showBase = false;
                that.detail = null;
                //成功后刷新数据
                that.getData(that.buyOrder.buyOrderCode);
            },
            closeTui() {
                const that = this;
                that.showTui = false;
                that.refund = null;
                //成功后刷新数据
                that.getData(that.buyOrder.buyOrderCode);
            }
        }
    };
</script>
<style scoped>
    .newButton {
        width: 2rem;
        margin: 0 0.1rem;
    }

    .newDiv {
        margin: 0.125rem;
        background: #fff;
        border: 1px solid #f0f0f0;
        border-radius: 0.16rem;
        padding: 0.1rem;
    }
</style>
